<template>
    <el-select
        v-model="selected"
        filterable
        remote
        reserve-keyword
        :placeholder="title"
        :remote-method="search"
        size="small"
        :title="selected"
        @change="change"
        clearable
        :disabled="disabled"
    >
        <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        defaultId: {
            type: Number,
            default: null,
        },
        defaultName: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: { type: String, default: "请输入员工名称" },
    },
    data() {
        return {
            selected: null,
            users: null,
        };
    },
    methods: {
        search(query) {
            let _this = this;

            _this.$http.post(
                ["/user/searchByName", { name: query }],
                [
                    function (data) {
                        _this.users = data;
                    },
                ],
                "none"
            );
        },
        change() {
            this.$emit("change", this.selected);
        },
        setDefault(id, name) {
            this.users = [{ id: id, name: name }];
            this.selected = id;
        },
        clear() {
            this.users = [];
            this.selected = null;
        }
    },
    watch: {
        defaultId(val) {
            this.setDefault(val, this.defaultName);
        },
    },
    mounted() {
        if (this.defaultId && this.defaultName) {
            this.setDefault(this.defaultId, this.defaultName);
        }
    },
};
</script>